import React from 'react';

import { Scrollchor, AnimateConfig, easeOutQuad } from 'react-scrollchor';

import covidModel from '@assets/images/covid-model.webp';

import { ReactComponent as Nature } from '@assets/images/icons/nature.svg';
import { ReactComponent as World } from '@assets/images/icons/world.svg';

const defaultAnimate: AnimateConfig = {
  offset: 124,
  duration: 600,
  easing: easeOutQuad,
};

type PageHeaderTypes = {
  isDesktopOrLaptop?: any;
  active?: boolean;
  onClick: (prop: boolean) => void;
};

export const PageHeader: React.FC<PageHeaderTypes> = ({ active, onClick, isDesktopOrLaptop }) => {

  return (
    <>
      <header id="main" className="flex flex-col lg:flex-row justify-between items-start w-full max-w-1160 mx-auto mt-22 lg:mt-31">
        <div className="flex-auto text-white pl-5 lg:pl-15">
          <h1
            className="
              text-4xl
              leading-50
              lg:leading-70
              lg:text-7xl
              tracking-0.66
              font-bold
              mb-7.5
              main-title
            "
          >
            Лабораторное
            <br />
            происхождение
            <br />
            коронавируса:
            <br />
            за и против
          </h1>
          <p className="main-text text-base mb-10 lg:mb-7.5 max-w-lg">
            В спецпроекте «Известий» приведены главные факты, собранные учеными и расследователями истока пандемии по всему миру. Сформируй собственное мнение. 
          </p>

          {isDesktopOrLaptop ?
            <Scrollchor
              animate={{ duration: 1000, easing: easeOutQuad, offset: -124 }}
              className="
                inline-flex
                border
                rounded-full
                px-6
                py-3
                transition
                hover:text-red-400
                hover:border-red-400
                main-btn
              "
              to="#first"
            >
              Подробнее
            </Scrollchor>
          :
            <div
              className="flex items-center mb-10 lg:mb-20 transition main-btn"
            >
              <div
                className={`
                  ${active ? 'bg-smGrayText' : 'bg-smGrayText'}
                  relative
                  inline-flex
                  justify-center
                  items-center
                  border
                  border-white
                  rounded-full
                  w-15
                  h-15
                  flex-shrink-0
                  z-10
                `}
              >
                <Nature
                  className={`
                    fill-current
                    ${active ? 'text-white' : 'text-white'}
                  `}
                  width={23}
                  height={36}
                />
              </div>
              <div
                className={`
                  ${active ? 'bg-smGrayText' : 'bg-smGrayText'}
                  relative
                  inline-flex
                  justify-center
                  items-center
                  border
                  border-white
                  rounded-full
                  w-15
                  h-15
                  flex-shrink-0
                  -ml-5
                `}
              >
                <World
                  className={`
                    fill-current
                    ${active ? 'text-white' : 'text-white'}
                  `}
                  width={37}
                  height={37}
                />
              </div>
              <span className="font-serif text-2xl text-lgGrayText mx-1.5">&#8594;</span>
              <p className="font-serif text-xs text-lgGrayText">
                Меняйте режим просмотра аргументов за природное или лабораторное происхождение
              </p>
            </div>
          }
        </div>
        <div className="lg:flex-auto flex justify-center w-full lg:w-auto overflow-hidden lg:overflow-visible mb-10 lg:mb-0">
          <div className="levitate relative mt-6 lg:mt-7.5 max-w-full">
            <img className="ml-8 lg:ml-0" src={covidModel} width="438" height="373" alt="" />
            <Scrollchor
              animate={{ duration: 1000, easing: easeOutQuad, offset: isDesktopOrLaptop ? -124 : -100 }}
              to="#video-3"
              beforeAnimate={() => onClick(false)}
              afterAnimate={() => {
                const videoLab = document.getElementById('video-3-lab');
                if (videoLab) {
                  const timer = setTimeout(() => {
                    videoLab.click();
                    clearTimeout(timer);
                  }, 400);
                }
              }}
            >
            <div className="dots dot-1"><i /></div>
              <div className="dots-info dots-info-1">
                Даже низковероятное событие может произойти
              </div>
            </Scrollchor>
            <Scrollchor
              animate={{ duration: 1000, easing: easeOutQuad, offset: isDesktopOrLaptop ? -124 : -50 }}
              to="#video-1"
              beforeAnimate={() => onClick(false)}
              afterAnimate={() => {
                const videoLab = document.getElementById('video-1-lab');
                if (videoLab) {
                  const timer = setTimeout(() => {
                    videoLab.click();
                    clearTimeout(timer);
                  }, 400);
                }
              }}
            >
            <div className="dots dot-2"><i /></div>
              <div
                className="dots-info dots-info-2"
              >
                С вирусами давно экспериментировали
              </div>
            </Scrollchor>
            <Scrollchor
              animate={{ duration: 1000, easing: easeOutQuad, offset: isDesktopOrLaptop ? -124 : -5 }}
              to="#video-2"
              beforeAnimate={() => onClick(true)}
              afterAnimate={() => {
                const videoLab = document.getElementById('video-2-nat');
                if (videoLab) {
                  const timer = setTimeout(() => {
                    videoLab.click();
                    clearTimeout(timer);
                  }, 400);
                }
              }}
            >
            <div className="dots dot-3"><i /></div>
              <div className="dots-info dots-info-3">
                Похожий на SARS-CoV-2 вирус есть у летучих мышей
              </div>
            </Scrollchor>
            <Scrollchor
              animate={{ duration: 1000, easing: easeOutQuad, offset: isDesktopOrLaptop ? -124 : -5 }}
              to="#video-2"
              beforeAnimate={() => onClick(false)}
              afterAnimate={() => {
                const videoLab = document.getElementById('video-2-lab');
                if (videoLab) {
                  const timer = setTimeout(() => {
                    videoLab.click();
                    clearTimeout(timer);
                  }, 400);
                }
              }}
            >
            <div className="dots dot-4"><i /></div>
              <div className="dots-info dots-info-4">
                В Уханьской лаборатории работали с коронавирусами
              </div>
            </Scrollchor>
            <Scrollchor
              animate={{ duration: 1000, easing: easeOutQuad, offset: isDesktopOrLaptop ? -124 : -5 }}
              to="#video-2"
              beforeAnimate={() => onClick(true)}
              afterAnimate={() => {
                const videoLab = document.getElementById('video-2-nat');
                if (videoLab) {
                  const timer = setTimeout(() => {
                    videoLab.click();
                    clearTimeout(timer);
                  }, 400);
                }
              }}
            >
            <div className="dots dot-5"><i /></div>
              <div className="dots-info dots-info-5">
                Вирусы обычно находят в природе
              </div>
            </Scrollchor>
          </div>
        </div>

      </header>

    </>
  );
}